export default {
    url: '/logout',
    template: '<div/>',
    controller (AuthService) {
        AuthService.logoutAndRedirect();
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/logout/index.js